import Vue from 'vue'

export default {
  get (id, config = {}) {
    return Vue.http.get(`/rental/reports/${id}`, {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/rental/report.js